import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Container, TextField } from '@/DesignSystem/Component';
import { messageCreateAction } from '@/Module/Contact/Store/Action/messageCreateAction';
import { FORM_GLOBAL_VALIDATION_ERROR } from '@/Module/Core/Constant';
import { yup } from '@/Module/Core/Helper';
import { IconMobile } from '@/Module/Icon';
import { useAppDispatch } from '@/Module/Store/Hook';
interface IForm {
  mobileNumber: string;
}
const SubscriptionPageForm: FC = () => {
  const dispatch = useAppDispatch();
  const schema = useMemo(() => {
    return yup.object({
      mobileNumber: yup.string().required().min(11, 'شماره تماس صحیح نیست.').max(11, 'شماره تماس صحیح نیست.')
    });
  }, []);
  const {
    control,
    handleSubmit,
    reset
  } = useForm<IForm>({
    resolver: yupResolver(schema)
  });
  const onSubmit = handleSubmit(data => {
    dispatch(messageCreateAction({
      mobileNumber: data.mobileNumber,
      messageTypeId: 3
    })).unwrap().then(() => {
      enqueueSnackbar({
        variant: 'success',
        message: 'شماره تماس با موفقیت ثبت گردید.'
      });
      reset();
    });
  }, () => {
    enqueueSnackbar({
      variant: 'error',
      message: FORM_GLOBAL_VALIDATION_ERROR
    });
  });
  return <div className="border-4 border-orangeFive bg-orangeThree " data-sentry-component="SubscriptionPageForm" data-sentry-source-file="SubscriptionPageForm.tsx">
      <Container className="max-w-[1100px]" data-sentry-element="Container" data-sentry-source-file="SubscriptionPageForm.tsx">
        <div className="flex flex-col flex-wrap items-center justify-center gap-4 pb-2 pt-8 sm:pb-8 sm:pt-14 lg:flex-row">
          <p className="text-center text-xl font-bold text-orangeSix md:text-right lg:max-w-[50%]">
            اگه دوست داری با مشاورای ما صحبت کنی و ازشون راهنمایی بگیری، میتونی شماره ات رو برامون اینجا بفرستی
          </p>
          <form className="relative flex flex-1 flex-col items-center gap-4 pb-6 sm:flex-row sm:pb-10" onSubmit={onSubmit}>
            <TextField errorClassName="sm:absolute bottom-0 right-0" control={control} name="mobileNumber" label="شماره همراه" prefix={<IconMobile />} className="  min-w-[260px] border-4 border-orangeThree shadow-theme shadow-orangeTwo " data-sentry-element="TextField" data-sentry-source-file="SubscriptionPageForm.tsx" />
            <Button className="mt-4 w-full sm:mt-0 sm:min-w-fit" variant="shadow" color="orange" radius="circle" type="submit" data-sentry-element="Button" data-sentry-source-file="SubscriptionPageForm.tsx">
              ثبت شماره همراه
            </Button>
          </form>
        </div>
      </Container>
    </div>;
};
export default SubscriptionPageForm;